import SeriesIndex from "../../../../src/components/web-industry-introduction-index";
import React from 'react';
export default {
  SeriesIndex,
  React
};